import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

import {Auftrag} from '../../data/auftrag';

@Component({
    selector: 'soft-auftrag-card',
    imports: [],
    templateUrl: './auftrag-card.component.html',
    styleUrls: ['./auftrag-card.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuftragCardComponent {
  @Input() auftrag?: Auftrag
}
